export default "__VITE_ASSET__D4l3R0$P__"